import axios from 'axios';
import { saveCountrySettings } from '../utils/languageLocalStorage';

import { countrySettings } from '../utils/variables';

import { SET_COUNTRY_SETTINGS, SET_PREVIOUS_LOCATION } from './actionTypes';

export function setCountrySettings(country) {
    const request = changeCountryAsync(country);
    return {
        type: SET_COUNTRY_SETTINGS,
        payload: request
    };
}

export function setPreviousLocation(pathname) {
    return {
        type: SET_PREVIOUS_LOCATION,
        payload: pathname
    };
}

const changeCountryAsync = country => {
    return new Promise(resolve => {
        saveCountrySettings(country);
        const settings = countrySettings[country];

        getLocalisedStrings(settings.locale).then(strings => {
            settings.localeStrings = strings;
            resolve(settings);
        });
    });
};

function getLocalisedStrings(locale) {
    if (process.env.NODE_ENV !== 'production') {
        return requireLocalStrings(locale);
    } else {
        return getProductionStrings(locale);
    }
}
const getProductionStrings = locale => {
    return new Promise(resolve => {
        if (locale === 'cs') {
            resolve(null);
            return
        }
        axios.get(`/translations/${locale}.json`).then(res => {
            resolve(res.data);
        });
    });
};

const requireLocalStrings = locale => {
    return new Promise(resolve => {
        if (locale === 'cs') {
            resolve(null);
            return
        }
        import(`../../public/translations/${locale}.json`).then(data => {
            resolve(data);
        });
    });
};
